
		import PageState from "./state"
		import mutations from "./mutations"
		import {getModule} from '@/store/store'
		let APIS = {
			//ajax地址
			startAiGenerates: `post /apis/moyin-tool/ai/doc/async/aiGenerate`,
			//获取用户信息
			getvipInfo: `get /apis/moyin-account/v1/vip/status`,
			postExtract: `post /apis/moyin-tool/v1/subtitles/asyncExtract`,
			//检测内容
			checkContent:{
				custom: true,
				method: 'post',
				url:'/apis/moyin-tool/tt/antiDirt'
			},
			// 取消任务
			deleteTask: `post /apis/moyin-tool/ai/doc/async/cancel`,

			getTaskResult: `get /apis/moyin-tool/ai/doc/async/result`,
			
		}
		export default {
			...getModule({
				state:new PageState(),
				mutations,
				actions:{},
				APIS,
				name:"textGeneratePage"
			})
		}